import Checkbox from "components/common/Checkbox/Checkbox";
import styled from "themes";
import theme from "themes/simple-theme-vh";
import { withDefaultProps } from "utils/react";

interface IHasFontSize {
  labelFontSize?: string;
}

export const StyledPurchaseCategoryCheckboxAndLabel = styled(Checkbox)``;



// WEBPACK FOOTER //
// ./src/screens/Budtender/Budtender.style.tsx